import * as React from 'react';

import url from './assets/icon.png';
import * as styles from './index.css';
import { trackClickOnBanner } from './tracking';

export function SuburbanBanner() {
  return (
    <section className={styles['container']}>
      <div className={styles['content']}>
        <span className={styles['title']}>Хотите продать недвижимость?</span>
        <span className={styles['subtitle']}>Разместите объявление на Циан</span>
        <div className={styles['button']}>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.cian.ru/razmestit-obyavlenie/"
            onClick={trackClickOnBanner}
          >
            Разместить
          </a>
        </div>
      </div>
      <img src={url} />
    </section>
  );
}
